export default __webpack_public_path__ + "static/media/container_tracking-green.06243f11.svg";